<template>
  <div class="files-upload-section">
    <h4>Upload files</h4>
    <div v-if="isUploadingFile" class="loading-section">
        <div class="spinner-border" role="status"></div>
    </div>
    <div class="files-upload-section__content">
      <file-picker
        header="Upload your own files for chatbot"
        ref="filePickerRef"
        :accept="acceptedFileTypes"
        :maxSize="52428800"
        :maxAmount="1"
        :validatedFiles="validatedFiles"
        :shouldClearSelectedFile="shouldClearSelectedFile"
        @onChange="onFileSelect"
      />

      <button
        class="button bg-primary rounded-pill"
        :disabled="isUploadButtonDisable"
        @click.prevent="onUpload"
      >
        Upload
      </button>
    </div>
  </div>
</template>
<script>
import { debounce } from 'underscore';
import FilePicker from '../../FilePickers/FilePicker.vue';
import aliceApi from '../../../alice-api';
import { getAcceptedExtensions } from '../../../utiles/formatHelper';

const ACCEPTED_MIME_TYPES = [
  'application/pdf',
  'text/plain',
  'text/markdown',
  'text/html',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/json',
  'application/epub+zip',
  'text/org',
  'text/x-rst',
];

export default {
  name: 'file-upload',
  components: {
    FilePicker,
  },
  data() {
    return {
      acceptedFileTypes: [...ACCEPTED_MIME_TYPES, ...getAcceptedExtensions(ACCEPTED_MIME_TYPES)],
      validatedFiles: [],
      shouldClearSelectedFile: false,
      isUploadingFile: false,
    };
  },
  computed: {
    isUploadButtonDisable() {
      if (this.validatedFiles.length < 1) return true;
      for (const validatedFiles of this.validatedFiles) {
        if (validatedFiles.isInvalid) return true;
      }
      return false;
    },
  },
  methods: {
    onFileSelect(files) {
      this.validatedFiles = files;
      if (this.validatedFiles.length < 1) {
        this.shouldClearSelectedFile = true;
      } else {
        this.shouldClearSelectedFile = false;
      }
    },
    onUpload: debounce(async function _ () {
      if (this.validatedFiles.length < 1) return;
      this.isUploadingFile = true;
      const formData = new FormData();
      formData.append('file', this.validatedFiles[0].data);
      formData.append('type', 'ai_assistant');

      try {
        await aliceApi.uploadKnowledgeFile(formData);

        this.validatedFiles = [];
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'File uploaded successfully.',
          position: 'is-bottom',
          duration: 3000,
        });

        return;
      } catch (error) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Upload failed.',
          position: 'is-bottom',
          duration: 3000,
        });
      } finally {
        this.isUploadingFile = false;
        this.shouldClearSelectedFile = true;
        this.$emit('on-reload-knowledge-file-list', true);
      }
    }, 800),
  },
};
</script>
<style lang="scss" scoped>
.files-upload-section {
  background-color: #fff;
  padding: 20px;
  position: relative;
  h4 {
    margin: 0px;
    font-weight: 500;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
    gap: 24px;
  }
  .loading-section{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: absolute;
    width: 100%;
    top: 0px;
    left: 0px;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 100;
  }
}
</style>
